import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { EditContactInfoModal } from './EditContactInfoModal';
import { Grid } from '@mui/material';
import { convertPhoneNumber, getCustomerEdit } from '../Shared/Functions';

const ContactInfo = ({ account, update, successToast, errorToast }) => {
    const [contactInfoModal, setContactInfoModal] = useState<boolean>(false);
    const [canEdit, setCanEdit] = useState<boolean>(false);
    const { street, street2, city, state, zip } = account.customer ?? {}

    useEffect(() => {
        getCustomerEdit().then((x:any) => {
            setCanEdit(x)
        })
    }, [])

    return (
        <>
            {/* modals */}
            {contactInfoModal &&
                <EditContactInfoModal
                    updateAccount={update}
                    hide={() => setContactInfoModal(false)}
                    show={contactInfoModal}
                    account={account}
                    fail={errorToast}
                    success={successToast} />
            }
            {/* end modals */}
            <Grid>
                <Grid container className='account-info' style={{ lineHeight: "2" }}>
                    <Grid item xs={canEdit ? 10 : 12}>
                        <div><b>CONTACT INFORMATION</b></div>
                    </Grid>
                    {canEdit &&
                        <Grid item xs={2} className='account-info-action' role="presentation" style={{ fontSize: ".9em" }}>
                            <Link to="/manage" onClick={() => setContactInfoModal(true)}>Edit</Link>
                        </Grid>
                    }
                    <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Account Name</b></Grid >
                    <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>{account.customer?.fullName}</Grid>
                    <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Billing Address</b></Grid >
                    <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>
            

                        {street} {street2} <br />
                        {city}, {state} {zip}
                    </Grid>
                
                    
                    {account.customer?.homePhone &&
                        <>
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Home Phone</b></Grid >
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>{convertPhoneNumber(account.customer?.homePhone)}</Grid>
                        </>
                    }
                    {account.customer?.cellPhone &&
                        <>
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Cell Phone</b></Grid >
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>{convertPhoneNumber(account.customer?.cellPhone)}</Grid>
                        </>
                    }
                    {account.customer?.workPhone &&
                        <>
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Work Phone</b></Grid >
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>{convertPhoneNumber(account.customer?.workPhone)}</Grid>
                        </>
                    }
                    {!account.customer?.homePhone && !account.customer?.cellPhone && !account.customer?.workPhone &&
                        <>
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Phone Number</b></Grid >
                            <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>Not Available</Grid>
                        </>
                    }
                    <Grid item className='account-info-item' style={{ fontSize: ".9em" }}><b>Email</b></Grid>
                    <Grid item className='account-info-item' style={{ fontSize: ".9em" }}>{account.customer?.email ? account.customer?.email : <>Not Available</>}</Grid>
                </Grid>
            </Grid>
        </>);
}
export default ContactInfo;